export default __webpack_public_path__ + "static/media/Dasan_Station_LE.86da78ea.jpg";